import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Auth, authSelectors } from '@content-platform/web-angular-shared-util-auth';
import {
  emailActions,
  EMAIL_TEMPLATES,
  EmailState,
  RequestNewUserEmail,
} from '@content-platform/web/angular/shared/util/email-api';
import { select, Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { MatDialogRef } from '@angular/material/dialog';
import { Configuration } from '@content-platform/web-angular-shared-util-configuration';
import { RoleSelectCloneComponent } from '@content-platform/reusable-ui/role-select-clone';
import { userProfileHelpers } from '@content-platform/web-angular-administration-shared-data-access-graph-api';

@Component({
  selector: 'app-user-request',
  templateUrl: './user-request.component.html',
  styleUrls: ['./user-request.component.scss'],
})
export class UserRequestComponent implements OnInit, OnDestroy {
  @ViewChild(RoleSelectCloneComponent) rolesChildComponent;

  userDataForm: FormGroup;
  private requestorName: string;
  private requestorEmail: string;
  private supportEmail: string;
  private emailSubject: string;
  private onDestroy = new Subject<void>();
  private requestedUserEmail: string;
  isUserSearchAdFormValid: boolean;
  invalidEmailMessage = 'This email already exists on Viacom environment';

  constructor(
    private authStore: Store<Auth>,
    private emailStore: Store<EmailState>,
    private dialogRef: MatDialogRef<UserRequestComponent>
  ) {}

  ngOnInit() {
    this.createForm();

    Configuration.getAsync('requestNewUser')
      .pipe(
        filter((config) => !!config),
        take(1)
      )
      .subscribe((config) => {
        this.supportEmail = config.email.to;
        this.emailSubject = config.email.subjectt;
      });

    this.authStore.pipe(select(authSelectors.getADUser), take(1)).subscribe(({ profile }) => {
      this.requestorName = userProfileHelpers.getDisplayName(profile);
      this.requestorEmail = userProfileHelpers.getEmailAddress(profile);
    });
  }

  createForm() {
    this.userDataForm = new FormGroup({
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      userSearchCtrl: new FormControl(''),
      userSearchCtrlRoles: new FormControl(''),
    });
  }

  sendNewUserRequestEmail() {
    const firstName = this.userDataForm.get('firstName').value;
    const lastName = this.userDataForm.get('lastName').value;
    const requestedUserName = `${firstName} ${lastName}`;
    const roles = this.rolesChildComponent.userRoleList.roles.map((item) => item.name);
    const clonedUser = this.rolesChildComponent.clonedUserName;

    const requestNewUserEmail: RequestNewUserEmail = {
      toAddr: this.supportEmail,
      CC: this.requestorEmail,
      subject: this.emailSubject,
      templateFileName: EMAIL_TEMPLATES.administrationRequestNewUser,
      requestorUserName: this.requestorName,
      requestedUserName: requestedUserName,
      requestedUserEmail: this.requestedUserEmail,
      requestedUserType: 'External',
      requestedUserRoles: roles,
      requestedClonedUser: clonedUser,
    };

    this.emailStore.dispatch(new emailActions.SendRequestNewUserEmail({ requestNewUserEmail }));
    this.cancel();
  }

  getChildFormStatus($event) {
    this.isUserSearchAdFormValid = $event === 'VALID';
  }

  getSelectedUser($event) {
    this.requestedUserEmail = $event;
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
  }

  cancel() {
    this.dialogRef.close();
  }
}
